import { render, staticRenderFns } from "./ZaikbnChip.vue?vue&type=template&id=223895c6"
import script from "./ZaikbnChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ZaikbnChip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports